import { render, staticRenderFns } from "./switchEdit.vue?vue&type=template&id=8d58d202&scoped=true"
import script from "./switchEdit.vue?vue&type=script&lang=js"
export * from "./switchEdit.vue?vue&type=script&lang=js"
import style0 from "./switchEdit.vue?vue&type=style&index=0&id=8d58d202&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d58d202",
  null
  
)

export default component.exports